import React from "react";
import { Alert, Box } from "@mui/material";
import { VISITOR } from "../../../constants/constants";
import VisitorDetail from "../visitor/VisitorDetail";
import ExhibitorDetail from "../exhibitor/profile/ExhibitorDetail";
import MuPb from "../../../widgets/MuPb";
import { getErrorResponse } from "../../../utils2024/utils";
import { useParams } from "react-router-dom";
import BackBtn from "../../../widgets/BackBtn";
import useApiEp from "../../../hooks/useApiEp";

const ProfileDetailCommon = () => {
  const { id } = useParams();
  const {
    isLoading,
    isError,
    error,
    data: response,
  } = useApiEp(`/user/get-user-by-id?id=${id}`);
  if (isLoading) {
    return <MuPb />;
  }

  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Box>
      <BackBtn />
      {response.role === VISITOR ? (
        <VisitorDetail data={response} />
      ) : (
        <ExhibitorDetail response={response} />
      )}
    </Box>
  );
};

export default ProfileDetailCommon;
